

export class ResponciveModule {

    /**
     * @constructor
     * @param {number} currentDesktopWidth current width of widget
     * @param {number} currentDesktopHeight current height of widget
     * @param {number} editedDesktopWidth width of widhet, when edited it
     * @param {number} editedDesktopHeight height of widget, when edited it
     * @param {number} currentMobileWidth current mobile width of widget
     * @param {number} currentMobileHeight current mobile height of widget
     * @param {number} editedMobileWidth mobile width of widhet, when edited it
     * @param {number} editedMobileHeight mobile height of widget, when edited it
     * @param {boolean} isMobile true if this is mobile version of site
     */
    constructor(currentDesktopWidth, currentDesktopHeight, editedDesktopWidth, editedDesktopHeight,
        currentMobileWidth, currentMobileHeight, editedMobileWidth, editedMobileHeight, isMobile) {
        this.defineCasheVariables(
            currentDesktopWidth, currentDesktopHeight, editedDesktopWidth, editedDesktopHeight,
            currentMobileWidth, currentMobileHeight, editedMobileWidth, editedMobileHeight
        );

        this.isMobile = isMobile;
        this.minDelta = null;
        this.abstractBox = null;


        this.defineAdaptiveVaribles();
        this.calculateMinDelta();
        this.createAbstractBox();

        // console.log(this.currentWidth, this.currentHeight, this.minDelta, this.editedDesktopWidth, this.editedDesktopHeight)
    }

    defineCasheVariables(currentWidth, currentHeight, editedWidth, editedHeight,
        currentMobileWidth, currentMobileHeight, editedMobileWidth, editedMobileHeight) {
        this.currentDesktopWidth = currentWidth;
        this.currentDesktopHeight = currentHeight;
        this.editedDesktopWidth = editedWidth;
        this.editedDesktopHeight = editedHeight;

        this.currentMobileWidth = currentMobileWidth;
        this.currentMobileHeight = currentMobileHeight;
        this.editedMobileWidth = editedMobileWidth;
        this.editedMobileHeight = editedMobileHeight;
    }


    defineAdaptiveVaribles() {
        // console.log('Adaptive var: ', this.isMobile);
        if (this.isMobile) {
            this.currentWidth = this.currentMobileWidth;
            this.currentHeight = this.currentMobileHeight;
            this.editedWidth = this.editedMobileWidth;
            this.editedHeight = this.editedMobileHeight;

            // properties to adapt
            this.positionProp = 'mobilePosition';
            this.relativeBoxPosition = 'relativePositionMobile';
            this.fonstSizeProp = 'mobileFontSize';
            this.dimensionsProp = 'dimensionsMobile';
            this.paddingProp = 'mobilePadding';
            this.heightProp = 'mobileHeight';
            this.widthProp = 'mobileWidth';
            this.borderWidthProp = 'mobileBorderWidth';
            this.borderRadiusProp = 'mobileBorderRadius';
            this.sizeProp = 'mobileSize';
            this.marginProp = 'mobileMargin';
            this.cubeHeightProp = 'mobileCubeHeight';
        } else {
            this.currentWidth = this.currentDesktopWidth;
            this.currentHeight = this.currentDesktopHeight;
            this.editedWidth = this.editedDesktopWidth;
            this.editedHeight = this.editedDesktopHeight;

            // properties to adapt
            this.positionProp = 'position';
            this.relativeBoxPosition = 'relativePosition';
            this.fonstSizeProp = 'fontSize';
            this.dimensionsProp = 'dimensions';
            this.paddingProp = 'padding';
            this.cubeHeightProp = 'cubeHeight';
            this.heightProp = 'height';
            this.widthProp = 'width';
            this.borderWidthProp = 'borderWidth';
            this.borderRadiusProp = 'borderRadius';
            this.sizeProp = 'size';
            this.marginProp = 'margin';
        }
    }


    calculateMinDelta() {

        // console.log('current width', this.currentWidth, 'edited width', this.editedWidth, 'current height', this.currentHeight, 'edited height', this.editedHeight)

        const deltaWidth = this.currentWidth / this.editedWidth;
        const deltaHeight = this.currentHeight / this.editedHeight;
        let minDelta = null;

        if (Math.abs(deltaWidth) < Math.abs(deltaHeight)) {
            minDelta = deltaWidth;
        } else {
            minDelta = deltaHeight;
        }
        // console.log('minDelta: ', minDelta);
        this.minDelta = minDelta;
        // if (this.minDelta > 1) {
        //     this.minDelta = 1;
        // }
    }


    createAbstractBox() {
        let box = {
            width: null,
            height: null,
            leftOffset: null,
            topOffset: null,
        }

        box.width = this.editedWidth * this.minDelta;
        // box.width = this.editedWidth;
        box.height = this.editedHeight * this.minDelta;
        // box.height = this.editedHeight;
        box.leftOffset = this.currentWidth / 2 - box.width / 2;
        box.topOffset = this.currentHeight / 2 - box.height / 2;
        // console.log('box: ', box);
        this.abstractBox = box;
    }

    set isMobile(newVal) {
        this._isMobile = newVal;
        this.defineAdaptiveVaribles();
        this.calculateMinDelta()
        this.createAbstractBox();
    }

    get isMobile() {
        return this._isMobile;
    }


    /**
     * 
     * @param {array} captions array of captions to adaptation
     * @returns {array} adapted captions
     */

    adaptCaptions(captions) {
        // 1 === current ration of widget equal editing widget ratio
        // console.log(this.minDelta);
        // console.log(this.minDelta === 1);
        // if (this.minDelta === 1) return captions;
        captions.forEach((caption, index) => {
            try {
                caption = this.alignCaptionPosition(caption);
                caption = this.adaptDimensions(caption);

                // if (!(caption[this.fonstSizeProp] === undefined)) {
                //     caption[this.fonstSizeProp] = caption[this.fonstSizeProp] * this.minDelta;
                //     caption[this.paddingProp] = caption[this.paddingProp] * this.minDelta;
                //     caption.borders.borderWidth = caption.borders.borderWidth * this.minDelta;
                //     caption.borders.borderRadius = caption.borders.borderRadius * this.minDelta;
                // }
                if (caption.type === 'text' || caption.type === 'button') {
                    if (caption[this.fonstSizeProp]) caption[this.fonstSizeProp] = Math.floor(caption[this.fonstSizeProp] * this.minDelta);
                    if (caption[this.paddingProp]) caption[this.paddingProp] = caption[this.paddingProp] * this.minDelta;
                    if (caption[this.borderRadiusProp]) caption[this.borderRadiusProp] = caption[this.borderRadiusProp] * this.minDelta;
                    if (caption.iconSettings && caption.iconSettings[this.sizeProp]) {
                        // console.log('iconSetttings adapt')
                        caption.iconSettings[this.sizeProp] = caption.iconSettings[this.sizeProp] * this.minDelta;
                        caption.iconSettings[this.marginProp] = caption.iconSettings[this.marginProp] * this.minDelta;
                    }
                    if (caption[this.cubeHeightProp]) caption[this.cubeHeightProp] = caption[this.cubeHeightProp] * this.minDelta;
                } else if (caption.type === 'image') {
                    if (caption[this.paddingProp]) caption[this.paddingProp] = caption[this.paddingProp] * this.minDelta;
                    if (caption[this.borderRadiusProp]) caption[this.borderRadiusProp] = caption[this.borderRadiusProp] * this.minDelta;
                } else {
                    // if (typeof caption[this.borderRadiusProp] === 'object') {
                    if (caption.shape === undefined && caption.shape == 'rectangle') {
                        for (let prop in caption[this.borderRadiusProp]) {
                            caption[this.borderRadiusProp][prop] = caption[this.borderRadiusProp][prop] * this.minDelta
                        }
                    }

                    // } else {
                    //     caption[this.borderRadiusProp] = caption[this.borderRadiusProp] * this.minDelta;
                    // }
                }
                // shadow
                if (caption.type === 'text') {
                    if (caption.shadow) {
                        caption.shadow = this.adaptTextShadow(caption.shadow)
                    }
                } else {
                    if (caption.shadow) {
                        caption.shadow = this.adaptBoxShadow(caption.shadow)
                    }

                    if (caption.type === 'button') {
                        if (caption.textShadow) {
                            caption.textShadow = this.adaptTextShadow(caption.textShadow)
                        }
                    }
                }

                if (caption[this.borderWidthProp]) caption[this.borderWidthProp] = caption[this.borderWidthProp] * this.minDelta;


            } catch (e) {
                console.error(e);
                console.log(caption);
            }
        })
        return captions;
    }

    adaptTextShadow(shadow) {
        shadow.x = shadow.x * this.minDelta
        shadow.y = shadow.y * this.minDelta
        shadow.blur = shadow.blur * this.minDelta
        return shadow
    }

    adaptBoxShadow(shadow) {
        shadow.x = shadow.x * this.minDelta
        shadow.y = shadow.y * this.minDelta
        shadow.blur = shadow.blur * this.minDelta
        shadow.size = shadow.size * this.minDelta
        return shadow
    }


    alignCaptionPosition(caption) {
        // console.log('caption',caption);
        if (caption[this.positionProp]) {
            caption[this.positionProp].x = Math.round(caption[this.positionProp].x * this.minDelta + this.abstractBox.leftOffset);
            caption[this.positionProp].y = Math.round(caption[this.positionProp].y * this.minDelta + this.abstractBox.topOffset);
        }

        // if(caption.childOf){
        if (caption.boxId && caption[this.positionProp] && caption[this.positionProp].relativeX != undefined) {
            // if(caption[this.relativeBoxPosition]){
            //     caption[this.relativeBoxPosition].x = caption[this.relativeBoxPosition].x * this.minDelta;
            //     caption[this.relativeBoxPosition].y = caption[this.relativeBoxPosition].y * this.minDelta;
            // }
            caption[this.positionProp].relativeX = Math.round(caption[this.positionProp].relativeX * this.minDelta);
            caption[this.positionProp].relativeY = Math.round(caption[this.positionProp].relativeY * this.minDelta);
        }

        return caption;
    }


    adaptDimensions(caption) {
        // caption[this.dimensionsProp].width = caption[this.dimensionsProp].width * this.minDelta;
        // caption[this.dimensionsProp].height = caption[this.dimensionsProp].height * this.minDelta;
        if (caption[this.widthProp]) caption[this.widthProp] = caption[this.widthProp] * this.minDelta;

        if (caption[this.heightProp]) caption[this.heightProp] = caption[this.heightProp] * this.minDelta;

        return caption;
    }

    /**
     * 
     * @param {array} captions array of captions to deadaptation
     * @returns {array} deadapted captions
    */

    deadaptCaptions(captions) {
        // 1 === current ration of widget equal editing widget ratio
        if (this.minDelta === 1) return captions;

        captions.forEach((caption, index) => {
            caption = this.dealignCaptionPosition(caption);
            caption = this.deadaptDimensions(caption);

            // if (!(caption[this.fonstSizeProp] === undefined)) {
            //     caption[this.fonstSizeProp] = caption[this.fonstSizeProp] / this.minDelta;
            //     caption[this.paddingProp] = caption[this.paddingProp] / this.minDelta;
            //     caption.borders.borderWidth = caption.borders.borderWidth / this.minDelta;
            //     caption.borders.borderRadius = caption.borders.borderRadius / this.minDelta;
            // }
            if (caption.type === 'text' || caption.type === 'button') {
                if (caption[this.fonstSizeProp]) caption[this.fonstSizeProp] = caption[this.fonstSizeProp] / this.minDelta;
                if (caption[this.paddingProp]) caption[this.paddingProp] = caption[this.paddingProp] / this.minDelta;
                if (caption[this.borderRadiusProp]) caption[this.borderRadiusProp] = caption[this.borderRadiusProp] / this.minDelta;
                if (caption.iconSettings && caption.iconSettings[this.sizeProp]) {
                    caption.iconSettings[this.sizeProp] = caption.iconSettings[this.sizeProp] / this.minDelta;
                    caption.iconSettings[this.marginProp] = caption.iconSettings[this.marginProp] / this.minDelta;
                }
                if (caption[this.cubeHeightProp]) caption[this.cubeHeightProp] = caption[this.cubeHeightProp] / this.minDelta;

            } else if (caption.type === 'image') {
                if (caption[this.paddingProp]) caption[this.paddingProp] = caption[this.paddingProp] / this.minDelta;
                if (caption[this.borderRadiusProp]) caption[this.borderRadiusProp] = caption[this.borderRadiusProp] / this.minDelta;
            } else {

                // if (typeof caption[this.borderRadiusProp] === 'object') {
                if (caption.shape === undefined && caption.shape == 'rectangle') {
                    for (let prop in caption[this.borderRadiusProp]) {
                        caption[this.borderRadiusProp][prop] = caption[this.borderRadiusProp][prop] / this.minDelta
                    }
                }
                // } else {
                //     caption[this.borderRadiusProp] = caption[this.borderRadiusProp] / this.minDelta;
                // }
            }
            if (caption[this.borderWidthProp]) caption[this.borderWidthProp] = caption[this.borderWidthProp] / this.minDelta;

        })
        return captions;
    }


    dealignCaptionPosition(caption) {
        if (caption[this.positionProp])
            caption[this.positionProp].x = Math.round(caption[this.positionProp].x / this.minDelta - this.abstractBox.leftOffset);
        caption[this.positionProp].y = Math.round(caption[this.positionProp].y / this.minDelta - this.abstractBox.topOffset);

        // if(caption.childOf){
        if (caption.boxId) {
            // if(caption[this.relativeBoxPosition]){
            //     caption[this.relativeBoxPosition].x = caption[this.relativeBoxPosition].x / this.minDelta;
            //     caption[this.relativeBoxPosition].y = caption[this.relativeBoxPosition].y / this.minDelta;
            // }
            caption[this.positionProp].relativeX = Math.round(caption[this.positionProp].relativeX / this.minDelta);
            caption[this.positionProp].relativeY = Math.round(caption[this.positionProp].relativeY / this.minDelta);
        }

        return caption;
    }


    deadaptDimensions(caption) {
        // caption[this.dimensionsProp].width = caption[this.dimensionsProp].width / this.minDelta;
        // caption[this.dimensionsProp].height = caption[this.dimensionsProp].height / this.minDelta;
        caption[this.widthProp] = caption[this.widthProp] / this.minDelta;
        caption[this.heightProp] = caption[this.heightProp] / this.minDelta;

        return caption;
    }

    convertCaptionRelativePosition(caption, captionsArray) {
        caption.mobilePosition.relativeX = Math.round(caption.position.relativeX * this.minDelta);
        caption.mobilePosition.relativeY = Math.round(caption.position.relativeY * this.minDelta);

        const parentBox = captionsArray.find(elem => elem.id === caption.boxId)

        // если родительский бокс уже конвертировался
        if (!parentBox.needMobileConvert) {
            // подвигаем внутренний элемент, чтобы он был внутри бокса
            if (caption.mobilePosition.relativeX + caption.mobileWidth > parentBox.mobileWidth) {
                caption.mobilePosition.relativeX = parentBox.mobileWidth - caption.mobileWidth
            }
            if (caption.mobilePosition.relativeX < 0) {
                caption.mobilePosition.relativeX = 0
            }
            if (caption.mobilePosition.relativeY + caption.mobileHeight > parentBox.mobileHeight) {
                caption.mobilePosition.relativeY = parentBox.mobileHeight - caption.mobileHeight
            }
            if (caption.mobilePosition.relativeY < 0) {
                caption.mobilePosition.relativeY = 0
            }
        }

        return caption
    }

    convertCaptionToMobile(caption, captionsArray, editorDiff = 1) {
        if (caption.mobilePosition === undefined) {
            caption.mobilePosition = {}
        }
        caption.mobilePosition.x = Math.round(caption.position.x * this.minDelta + this.abstractBox.leftOffset);
        caption.mobilePosition.y = Math.round(caption.position.y * this.minDelta + this.abstractBox.topOffset);
        caption.mobileWidth = Math.ceil(caption.width * this.minDelta);
        caption.mobileHeight = Math.ceil(caption.height * this.minDelta);
        if (caption.boxId) {
            caption = this.convertCaptionRelativePosition(caption, captionsArray)

        }
        // если у капчи стили были скопированы, то, чтобы их не сбить, адаптируем только положение
        if (!caption.needMobileConvertOnlyPosition) {
            console.log('converting all')
            // веджет в редакторе не равен по размерам виджету на сайте
            // отношение размеров этих виджетов editorDiff используем как коэффициент при расчёте convertRatio
            let convertRatio = this.minDelta / editorDiff

            if (caption.type === 'box' || caption.type === 'shape') {
                if (caption.borderRadius) {
                    caption.mobileBorderRadius = {
                        leftBottom: this.getStyleConvertedToMobile(caption.borderRadius.leftBottom, convertRatio),
                        leftTop: this.getStyleConvertedToMobile(caption.borderRadius.leftTop, convertRatio),
                        rightBottom: this.getStyleConvertedToMobile(caption.borderRadius.rightBottom, convertRatio),
                        rightTop: this.getStyleConvertedToMobile(caption.borderRadius.rightTop, convertRatio)
                        // leftBottom: caption.borderRadius.leftBottom * diffW,
                        // leftTop: caption.borderRadius.leftTop * diffW,
                        // rightBottom: caption.borderRadius.rightBottom * diffW,
                        // rightTop: caption.borderRadius.rightTop * diffW
                    }
                } else {
                    console.log('Error: caption border object is', caption.borderRadius, ' in responsiveModule.js')
                }

                caption.separateCornersMobile = caption.separateCorners
            } else if (caption.type === 'image') {
                // console.log('converting image')
                caption.mobileBorderRadius = this.getStyleConvertedToMobile(caption.borderRadius, convertRatio);
                caption.mobilePadding = this.getStyleConvertedToMobile(caption.padding, convertRatio);
                caption.mobileCrop = caption.crop;
            } else {
                caption.mobileFontSize = Math.floor(caption.fontSize * convertRatio);
                // беру изменение размеров шрифта за базу,
                // чтобы меньше было перескакиваний текста на другие строки
                convertRatio = caption.mobileFontSize / caption.fontSize
                caption.mobileLetterSpacing = caption.letterSpacing;
                caption.mobileLineHeight = caption.lineHeight;
                caption.mobilePadding = Math.floor(caption.padding * convertRatio);
                if (caption.iconSettings && caption.iconSettings.size) {
                    caption.iconSettings.mobileSize = Math.floor(caption.iconSettings.size * convertRatio);
                    caption.iconSettings.mobileMargin = Math.floor(caption.iconSettings.margin * convertRatio);
                }
                caption.mobileBorderRadius = this.getStyleConvertedToMobile(caption.borderRadius, convertRatio);
            }
            caption.mobileBorderWidth = this.getStyleConvertedToMobile(caption.borderWidth, convertRatio);

        }

        return caption
    }

    convertCaptionToMobileAbsentFields(caption, captionsArray, editorDiff = 1) {
        // console.log('absent fields')
        if (caption.mobilePosition === undefined) {
            caption.mobilePosition = {}
        }
        if (caption.mobilePosition.x === undefined) caption.mobilePosition.x = Math.round(caption.position.x * this.minDelta + this.abstractBox.leftOffset);

        if (caption.mobilePosition.y === undefined) caption.mobilePosition.y = Math.round(caption.position.y * this.minDelta + this.abstractBox.topOffset);
        if (caption.mobileWidth === undefined) caption.mobileWidth = Math.ceil(caption.width * this.minDelta);
        if (caption.mobileHeight === undefined) caption.mobileHeight = Math.ceil(caption.height * this.minDelta);
        // если у капчи стили были скопированы, то, чтобы их не сбить, адаптируем только положение
        // веджет в редакторе не равен по размерам виджету на сайте
        // отношение размеров этих виджетов editorDiff используем как коэффициент при расчёте convertRatio
        let convertRatio = this.minDelta / editorDiff

        if (caption.type === 'box' || caption.type === 'shape') {
            if (caption.borderRadius && caption.mobileBorderRadius === undefined) {
                caption.mobileBorderRadius = {
                    leftBottom: this.getStyleConvertedToMobile(caption.borderRadius.leftBottom, convertRatio),
                    leftTop: this.getStyleConvertedToMobile(caption.borderRadius.leftTop, convertRatio),
                    rightBottom: this.getStyleConvertedToMobile(caption.borderRadius.rightBottom, convertRatio),
                    rightTop: this.getStyleConvertedToMobile(caption.borderRadius.rightTop, convertRatio)
                    // leftBottom: caption.borderRadius.leftBottom * diffW,
                    // leftTop: caption.borderRadius.leftTop * diffW,
                    // rightBottom: caption.borderRadius.rightBottom * diffW,
                    // rightTop: caption.borderRadius.rightTop * diffW
                }
            } else {
                console.log('Error: caption border object is', caption.borderRadius, ' in responsiveModule.js')
            }

            if (caption.separateCornersMobile === undefined) caption.separateCornersMobile = caption.separateCorners
        } else if (caption.type === 'image') {
            // console.log('converting image')
            if (caption.mobileBorderRadius === undefined) caption.mobileBorderRadius = this.getStyleConvertedToMobile(caption.borderRadius, convertRatio);
            if (caption.mobilePadding === undefined) caption.mobilePadding = this.getStyleConvertedToMobile(caption.padding, convertRatio);
            if (caption.mobileCrop === undefined) caption.mobileCrop = caption.crop;
        } else {
            if (caption.mobileFontSize === undefined) caption.mobileFontSize = Math.floor(caption.fontSize * convertRatio);
            // беру изменение размеров шрифта за базу,
            // чтобы меньше было перескакиваний текста на другие строки
            convertRatio = caption.mobileFontSize / caption.fontSize
            if (caption.mobileLetterSpacing === undefined) caption.mobileLetterSpacing = caption.letterSpacing;
            if (caption.mobileLineHeight === undefined) caption.mobileLineHeight = caption.lineHeight;
            if (caption.mobilePadding === undefined) caption.mobilePadding = Math.floor(caption.padding * convertRatio);
            if (caption.iconSettings && caption.iconSettings.size && caption.iconSettings.mobileSize === undefined) {
                caption.iconSettings.mobileSize = Math.floor(caption.iconSettings.size * convertRatio);
                caption.iconSettings.mobileMargin = Math.floor(caption.iconSettings.margin * convertRatio);
            }
            if (caption.textStroke && caption.textStroke.size !== undefined && caption.textStroke.mobileSize === undefined) {
                caption.textStroke.mobileSize = caption.textStroke.size * convertRatio
            }
            if (caption.mobileBorderRadius === undefined) caption.mobileBorderRadius = this.getStyleConvertedToMobile(caption.borderRadius, convertRatio);
        }
        if (caption.mobileBorderWidth === undefined) caption.mobileBorderWidth = this.getStyleConvertedToMobile(caption.borderWidth, convertRatio);


        return caption
    }

    getStyleConvertedToMobile(desktopValue, diff) {
        let mobileValue = Math.round(desktopValue * diff)
        if (desktopValue >= 1 && mobileValue < 1) {
            mobileValue = 1
        }
        return mobileValue
    }

    convertSlideCaptionsToMobile(captions, editorDiff = 1) {
        let someCaptionWasConverted = false

        captions.map((caption, i, captionsArray) => {
            // если капчу создали, но ни разу её не редактировали в мобильном виде,
            // то адаптируем её по образу и подобию десктопной капчи

            if (caption.needMobileConvert === true) {
                caption = this.convertCaptionToMobile(caption, captionsArray, editorDiff);
                // caption = convertCaptionToMobile(caption, diffW, diffH)
                delete caption.needMobileConvert
                delete caption.needConvertOnlyPosition
                someCaptionWasConverted = true
            } else {
                // caption = this.convertCaptionToMobileAbsentFields(caption, captionsArray, editorDiff)
            }
        })

        return { captions, someCaptionWasConverted }
    }

    convertFromDesktopToMobileOld(captions) {
        const diffW = this.currentMobileWidth / this.editedDesktopWidth
        const diffH = this.currentMobileHeight / this.editedDesktopHeight
        captions.map((caption, index) => {
            if (caption.needMobileConvert) {
                caption.mobilePosition = {}
                caption.mobilePosition.x = Math.round(caption.position.x * diffW)
                caption.mobilePosition.y = Math.round(caption.position.y * diffH)
                if (caption.boxId != '') {
                    caption.mobilePosition.relativeX = Math.round(caption.position.relativeX * diffW)
                    caption.mobilePosition.relativeY = Math.round(caption.position.relativeY * diffH)
                }
                caption.mobileWidth = Math.ceil(caption.width * diffW)
                caption.mobileHeight = Math.ceil(caption.height * diffH)
                delete caption.needMobileConvert
                if (caption.mobileBorderRadius !== undefined) delete caption.mobileBorderRadius
                if (caption.mobilePadding !== undefined) delete caption.mobilePadding
                if (caption.mobileBorderWidth !== undefined) delete caption.mobileBorderWidth
                if (caption.mobileFontSize !== undefined) delete caption.mobileFontSize
                if (caption.mobileLineHeight !== undefined) delete caption.mobileLineHeight
                if (caption.mobileLetterSpacing !== undefined) delete caption.mobileLetterSpacing
            }
        })
        return captions
    }

}

